import { Button, CloseIcon } from "@fluentui/react-northstar";

import {
    ChevronRight20Regular,
    ChevronLeft20Regular,
} from "@fluentui/react-icons";
import { steps_tour_guide_chat_bot } from "./steps_chatbot";
import {
    Ball,
    Buttons,
    Hr,
    TooltipTitle,
    WrapperBalls,
    WrapperBallsAndNext,
    WrapperTitle,
    WrapperTooltip,
} from "./guide.style";

export const TooltipComponent = ({
    continuous,
    index,
    step,
    size,
    backProps,
    closeProps,
    primaryProps,
    tooltipProps,
}) => {
    const LEN_STEPS = steps_tour_guide_chat_bot.length;
    return (
        <WrapperTooltip {...tooltipProps}>
            {step.title && (
                <WrapperTitle>
                    <TooltipTitle>{step.title}</TooltipTitle>{" "}
                    <Button
                        {...closeProps}
                        iconOnly
                        text
                        icon={<CloseIcon styles={{ color: "white" }} />}
                    />
                </WrapperTitle>
            )}
            <div>{step.content}</div>
            <Hr />
            <WrapperBallsAndNext>
                <div style={{ minWidth: "30px" }}>
                    {index > 0 && (
                        <Button
                            {...backProps}
                            id="back"
                            iconOnly
                            text
                            icon={
                                <ChevronLeft20Regular
                                    style={{ color: "white" }}
                                />
                            }
                        />
                    )}
                </div>
                <WrapperBalls>
                    {LEN_STEPS > 1 &&
                        new Array(LEN_STEPS).fill("").map((e, i) => {
                            return <Ball $active={i === index}>•</Ball>;
                        })}
                </WrapperBalls>
                <div style={{ minWidth: "30px" }}>
                    {index < steps_tour_guide_chat_bot.length - 1 && (
                        <Button
                            {...primaryProps}
                            id="next"
                            iconOnly
                            text
                            icon={
                                <ChevronRight20Regular
                                    style={{ color: "white" }}
                                />
                            }
                        />
                    )}
                </div>
            </WrapperBallsAndNext>
            <Buttons>
                <Button
                    {...closeProps}
                    id="close"
                    content={"J'ai compris"}
                    text
                    size="small"
                    inverted
                    styles={{
                        border: 0,
                        textDecoration: "underline",
                        paddingLeft: 0,
                    }}
                />
            </Buttons>
        </WrapperTooltip>
    );
};
